module.exports = __webpack_public_path__ + "img/xero-seeklogo.d8a3b226.png";